import { render, staticRenderFns } from "./extract-template-detail.vue?vue&type=template&id=097afc8d&scoped=true"
import script from "./extract-template-detail.vue?vue&type=script&lang=js"
export * from "./extract-template-detail.vue?vue&type=script&lang=js"
import style0 from "./extract-template-detail.vue?vue&type=style&index=0&id=097afc8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097afc8d",
  null
  
)

export default component.exports